<div class="filter filter-padded filter-double-padded-right">
  <span class="filter-body">
    <div class="filter-title filter-label table-checkbox-group">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!advancedConditions.hasInfluence" [disabled]="!isActive || advancedConditions.veiled || advancedConditions.fractured"
          (click)="toggleInfluenced()"></button>
      </span>
      <span class="table-checkbox-label">
        @if (isMobile()) {
          <app-tooltip-wrapper>
            <ng-template #tooltip>Influenced</ng-template>
            <img src="{{ imgPrefix }}/img/icons/influenced.png">
          </app-tooltip-wrapper>
        } @else {
          <img src="{{ imgPrefix }}/img/icons/influenced.png"> Influenced
        }
      </span>
    </div>
    <span class="sep"></span>
    <app-autocomplete style="width: 100px"
      [options]="influences"
      [disabled]="!isActive || !advancedConditions.hasInfluence"
      [showOptions]="true"
      [selectedValues]="advancedConditions.influences || ['All']"
      (selectedValuesChange)="advancedConditions.influences = $event; updateFilter();"
    ></app-autocomplete>
    <span class="sep"></span>
    <div class="filter-title filter-label table-checkbox-group">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!advancedConditions.fractured" [disabled]="!isActive || advancedConditions.hasInfluence || advancedConditions.veiled"
          (click)="toggleFractured()"></button>
      </span>
      <span class="table-checkbox-label">
        @if (isMobile()) {
          <app-tooltip-wrapper>
            <ng-template #tooltip>Fractured</ng-template>
            <img src="{{ imgPrefix }}/img/icons/fractured.png">
          </app-tooltip-wrapper>
        } @else {
          <img src="{{ imgPrefix }}/img/icons/fractured.png"> Fractured
        }
      </span>
    </div>
    <span class="spacer" style="display: table-cell; width: 100%;"></span>
  </span>
</div>
<div class="filter filter-padded filter-double-padded-right">
  <span class="filter-body">
    <div class="filter-title filter-label table-checkbox-group">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!advancedConditions.veiled" [disabled]="!isActive || advancedConditions.hasInfluence || advancedConditions.fractured"
          (click)="toggleVeiled()"></button>
      </span>
      <span class="table-checkbox-label">
        @if (isMobile()) {
          <app-tooltip-wrapper>
            <ng-template #tooltip>Veiled</ng-template>
            <img src="{{ imgPrefix }}/img/icons/veiled.png">
          </app-tooltip-wrapper>
        } @else {
          <img src="{{ imgPrefix }}/img/icons/veiled.png"> Veiled
        }
      </span>
    </div>
    <span class="sep"></span>
    <app-autocomplete style="width: 100px"
      [allLabel]="'All Veiled'"
      [options]="syndicateMembers"
      [disabled]="!isActive || !advancedConditions.veiled"
      [showOptions]="true"
      [selectedValues]="advancedConditions.veiledOfSyndicateMembers || ['All Veiled']"
      (selectedValuesChange)="advancedConditions.veiledOfSyndicateMembers = $event; updateFilter()">
    </app-autocomplete>
    <span class="sep"></span>
    <div class="filter-title filter-label">
      @if (isMobile()) {
        <app-tooltip-wrapper>
          <ng-template #tooltip>Memory Strands</ng-template>
          <img src="{{ imgPrefix }}/img/icons/memory-strand.png">
        </app-tooltip-wrapper>
      } @else {
        <img src="{{ imgPrefix }}/img/icons/memory-strand.png"> Memory Strands
      }
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="3" min="1" max="10" pattern="[1-10]" inputmode="numeric" step="any" class="form-control minmax"
      [disabled]="!isActive"
      [(ngModel)]="advancedConditions.minMemoryStrands" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    <span class="spacer" style="display: table-cell; width: 100%;"></span>
  </span>
</div>
<div class="filter filter-padded filter-double-padded-right">
  <span class="filter-body">
    <div class="filter-title filter-label" style="width: 90px">
      {{ isMobile() ? 'Corr.' : 'Corrupted' }}
    </div>
    <span class="sep"></span>
    <app-select [(ngModel)]="advancedConditions.corrupted" (selectedValueChange)="updateFilter()" [disabled]="!isActive" style="width: 65px;">
      <app-option [value]="undefined" [text]="'Any'"></app-option>
      <app-option [value]="YesNoAny.Yes" [text]="'Yes'"></app-option>
      <app-option [value]="YesNoAny.No" [text]="'No'"></app-option>
    </app-select>
    <span class="sep"></span>
    <div class="filter-title filter-label">
      {{ isMobile() ? 'Impl.' : 'Corr. Impl.' }}
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="1" pattern="[0-2]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!isActive" [(ngModel)]="advancedConditions.corruptedImplicits" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    <span class="sep"></span>
    <div class="filter-title filter-label">
      {{ isMobile() ? 'Qual.' : 'Quality' }}
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="3" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!isActive" [(ngModel)]="advancedConditions.minQuality" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    @if (isArmour) {
      <span class="sep"></span>
      <div class="filter-title filter-label">
        {{ isMobile() ? 'Def. %' : 'Def. Perc.' }}
      </div>
      <span class="sep"></span>
      <input type="number" placeholder="min" maxlength="3" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!isActive" [(ngModel)]="advancedConditions.minBaseDefencePercentile" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    }
    <span class="spacer" style="display: table-cell; width: 100%;"></span>
  </span>
</div>
